module.exports = __webpack_public_path__ + "img/shortandsweet.fa0840ec.svg";